export function normalizeChartResolution(resolution) {
  const value = String(resolution || "").trim().toUpperCase().replace(/^_/, "");
  if (value === "5M") return "5";
  if (value === "15M") return "15";
  if (value === "4H") return "240";
  if (value === "D") return "1D";
  if (value === "W") return "1W";
  return value;
}

function resolutionDurationMs(resolution) {
  const normalized = normalizeChartResolution(resolution);
  if (/^\d+$/.test(normalized)) return Number(normalized) * 60 * 1000;
  if (normalized === "1D") return 24 * 60 * 60 * 1000;
  if (normalized === "1W") return 7 * 24 * 60 * 60 * 1000;
  return null;
}

export function findCandleForCursor(candlesByTime, cursorTime, resolution) {
  if (!candlesByTime || cursorTime == null) return null;
  const millis = Number(cursorTime) < 100000000000
    ? Number(cursorTime) * 1000
    : Number(cursorTime);
  const exact = candlesByTime.get(millis);
  if (exact) return exact;

  const duration = resolutionDurationMs(resolution);
  if (!duration) return null;
  for (const [start, candle] of candlesByTime.entries()) {
    const candleStart = Number(start);
    if (candleStart <= millis && millis < candleStart + duration) return candle;
  }
  return null;
}
